var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPhone = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.222 6.254c.022-1.564 3.303-2.141 3.77-1.992.795.253 2.431 3.465 2.121 3.748-.487.446-1.588 1.867-1.603 2.175-.055 1.133 3.784 5.432 4.938 5.528.313.026 1.895-.856 2.41-1.271.327-.264 3.358 1.75 3.51 2.557.088.473-.928 3.585-2.513 3.4-6.075-.032-13.27-8.192-12.633-14.145",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };